import { InjectionToken } from '@angular/core';

/** The app supplies creation without making building discovery depend on its owner. */
export const BUILDING_CREATION_INTENT = new InjectionToken<
    (onReady?: () => void) => void | Promise<void>
>('Building creation intent');
